module.exports = __webpack_public_path__ + "static/media/nodejs.0451ed2e.png";